import React from 'react';
import classnames from 'classnames';

import './index.scoped.less';

interface BreathingDotProps {
  show?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const BreathingDot: React.FC<BreathingDotProps> = (props) => {
  const { className, style, show, children = null } = props;
  return (
    <div className="with-breathing-dot">
      {children}
      {show && <div className={classnames('breathing-dot', className)} style={style}>
        <div className="breathing-dot-box">
          <div className="breathing-dot-outer">
            <div className="breathing-dot-inner"></div>
          </div>
        </div>
      </div>}
    </div>
  );
};
export default BreathingDot;

